import { ContractorType } from '@insurance/api/requests'
import { SelectProps } from 'antd'
import { TFunction } from 'i18next'

export const typeList = Object.values(ContractorType)

export const typeOptions = (t: TFunction): SelectProps['options'] =>
  typeList.map((value) => ({
    label: t(value),
    value
  }))
